import { createApp } from 'vue';
import EpubToDocxConverter from '@/Components/EpubToDocxConverter.vue';
import '@styles/app.css';

createApp(EpubToDocxConverter).mount('#epub-to-docx-converter');
